/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';
import Content from 'app/components/common/Content.jsx';
import Header from 'app/components/Headers/CreateFeedHeader.jsx';
import CreateFeed from 'app/components/CreateFeed/CreateFeed.jsx';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import setInputDefaults from 'app/mixins/InputDefaultsModule.js';
import InputModal from 'app/components/InputModal/InputModal.jsx';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import FeedProvider from 'app/redux/Providers/FeedProvider.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';

class InputNew extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			routeId: this.props.router.params.routeId,
			route: {},
			inputs: [],
			canAddFeeds: true,
			saveButtonActive: false,
			errors: null,
			inputToConfigure: null,
			currentModal: null,
			feedValidating: false,
			searchErrors: null
		};

		this.createInput = this.createInput.bind(this);
		this.addInputToRoute = this.addInputToRoute.bind(this);
		this.onConfigClick = this.onConfigClick.bind(this);
		this.onConfigSave = this.onConfigSave.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.onRemoveInput = this.onRemoveInput.bind(this);
		this.storeRouteState = this.storeRouteState.bind(this);
		this.onSubtypeClick = this.onSubtypeClick.bind(this);
		this.cancelCreation = this.cancelCreation.bind(this);

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			inputs = state.inputs,
			i = 0,
			j = 0,
			updateState = false,
			saveButtonActive = true;

		for (i = 0; i < props.automatedRoutes.list.length; ++i) {
			if (parseInt(props.automatedRoutes.list[i].id, 10) === parseInt(state.routeId, 10)) {
				if (!_.isEqual(props.automatedRoutes.list[i], state.route)) {
					nextState.route = props.automatedRoutes.list[i];
				}
				break;
			}
		}

		if (props.automatedRoutes.validInputs.length) {
			for (i = 0; i < props.automatedRoutes.validInputs.length; ++i) {
				for (j = 0; j < inputs.length; ++j) {
					if (parseInt(props.automatedRoutes.validInputs[i].id, 10) === parseInt(inputs[j].id, 10) && (inputs[j].inputValid === false || inputs[j].inputValid === undefined)) {
						nextState.feedValidating = false;
						if (!_.isEmpty(state.inputToConfigure) && parseInt(state.inputToConfigure.id, 10) === parseInt(inputs[j].id, 10)) {
							inputs[j] = props.automatedRoutes.validInputs[i];
							nextState.inputToConfigure = {};
						}
						inputs[j].inputValid = true;
						updateState = true;
					}
				}
			}
			if (updateState) {
				nextState.inputs = inputs;
				props.clearValidatedInputs();
			}
			for (i = 0; i < inputs.length; ++i) {
				if (inputs[i].inputValid !== undefined && inputs[i].inputValid === false) {
					saveButtonActive = false;
				}
			}
			if (saveButtonActive != state.saveButtonActive) {
				nextState.saveButtonActive = saveButtonActive;
			}
		}

		return (Object.keys(nextState).length) ? nextState : null;
	}


	componentDidMount() {

		this.props.restorePeristedData("newInputs", this.props.cleanUpInputState, this);
		this.props.getRoute(this.state.routeId);

		if (this.props.router.location.pathname.match('configure') && this.state.inputs.length === 0) {
			this.props.router.navigate('/share/automate/detail/' + this.state.routeId + '/input/new');
		}

	}

	componentDidUpdate(prevProps, prevState) {
		let route = this.state.route,
			input = {},
			errors = [],
			prevRoute = {},
			currentRoute = {};


		if (this.props.authState.credID) {
			if (this.props.authState.credID.match(/^INPUT/)) {
				this.props.authReturnHandler({
					path: '/share/automate/detail/' + this.state.routeId + '/input/new/configure'
				},
				this.createInput);
				this.props.resetAuthState();
			}
		}

		errors = this.props.getApiErrors(['INPUT_VALIDATE', 'INPUT_CREATE']);
		if (errors.length && this.state.errors === null) {
			this.setState({
				errors: errors[0],
				saveButtonActive: false
			});
		}

		errors = this.props.getApiErrors(['FEED_SEARCH']);
		if (errors.length && this.state.searchErrors === null) {
			this.setState({
				searchErrors: errors[0]
			});
		}

		if (prevProps.automatedRoutes.validInputs.length < this.props.automatedRoutes.validInputs.length ||
			prevState.errors === null && this.state.errors !== null) {
			this.setState({
				feedValdating: false
			});
		}

		prevRoute = this.props.findRoute(this.state.routeId, prevProps);
		currentRoute = this.props.findRoute(this.state.routeId);

		if (prevRoute !== null && currentRoute !== null) {
			if (prevRoute.inputs.length < currentRoute.inputs.length) {
				this.props.router.navigate('/share/automate/detail/' + this.state.routeId);
			}
		}

		errors = this.props.getApiErrors(['INPUT_VALIDATE', 'INPUT_CREATE']);
		if (errors.length && this.state.errors === null) {
			this.setState({
				errors: errors[0],
				saveButtonActive: false
			});
		}

		errors = this.props.getApiErrors(['FEED_SEARCH']);
		if (errors.length && this.state.searchErrors === null) {
			this.setState({
				searchErrors: errors[0]
			});
		}

		if (prevProps.automatedRoutes.validInputs.length < this.props.automatedRoutes.validInputs.length ||
			prevState.errors === null && this.state.errors !== null) {
			this.setState({
				feedValdating: false
			});
		}

		if (!_.isEmpty(this.state.inputToConfigure)) {
			if (this.state.inputToConfigure.inputValid === true && this.props.router.location.pathname.match('configure')) {
				this.onModalClose(this.state.inputToConfigure);
			}
		}


	}

	createInput(input) {
		let inputs = this.state.inputs,
			constants = this.props.app.config.constants,
			inputToConfigure = null,
			feedValidating = this.state.feedValidating;

		setInputDefaults.apply(this, [input, input.type, this.props.user.perms, constants.R_DEFAULT]);
		input.rID = parseInt(this.state.routeId);
		inputs.push(input);

		if (input.type == constants.INPUT_TYPE_FEED && input.subtype === undefined) {
			this.props.validateInput(input);
			feedValidating = true;
		} else if (input.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
			inputToConfigure = input;
			this.props.router.navigate('/share/automate/detail/' + this.state.routeId + '/input/new/configure');
		} else {
			inputToConfigure = input;
		}

		

		this.setState({
			inputs,
			inputToConfigure,
			feedValidating
		}, () => {
			this.props.resetAuthState();
			// clean up any persisted state
			this.props.clearPersistedData('newInputs');
		});

	}


	addInputToRoute() {

		for (let i = 0; i < this.state.inputs.length; ++i) {
			this.props.createInput(this.state.inputs[i]);
		}

	}

	onConfigClick(event) {
		let input = {},
			i = 0,
			id = event.currentTarget.dataset.feedid;

		for (i = 0; i < this.state.inputs.length; ++i) {
			if (this.state.inputs[i].id == id) {
				input = this.state.inputs[i];
				input.inputValid = false;
				break;
			}
		}

		this.setState({
			inputToConfigure: input
		}, () => {
			this.props.router.navigate('/share/automate/detail/' + this.state.routeId + '/input/new/configure');
		});


	}

	onConfigSave(input) {

		this.setState({
			inputToConfigure: input
		});

		this.props.validateInput(input);

	}

	onModalClose(input) {
		let inputs = this.state.inputs,
			newInputs = [],
			i = 0,
			errors = this.state.errors;

		// InputModal::closeInputModal compares state to props 'input' and if they're the same
		// sets dirty to false which can be used to set inputValid to true after setting it to false
		// when the modal is shown
		if (input.dirty !== undefined && input.dirty === false) {
			input.inputValid = true;
		}

		for (i = 0; i < inputs.length; ++i) {
			if ((_.isEqual(inputs[i], input) && inputs[i].inputValid === true) ||
			 	!_.isEqual(inputs[i], input)) {
				newInputs.push(inputs[i]);
			} else {
				if (this.state.errors) {
					this.props.deleteApiError(['INPUT_VALIDATE', 'INPUT_CREATE']);
					errors = null;
				}
			}
		}

		this.setState({
			inputs: newInputs,
			errors: errors
		});

		this.props.router.navigate('/share/automate/detail/' + this.state.routeId + '/input/new');

	}

	onRemoveInput(feedId) {
		let inputs = this.state.inputs,
			updatedInputs = [],
			i = 0,
			buttonActive = this.state.saveButtonActive;

		for (i = 0; i < inputs.length; ++i) {
			if (inputs[i].id != feedId) {
				updatedInputs.push(inputs[i]);
			}
		}

		if (updatedInputs.length === 0) {
			buttonActive = false;
		}

		this.props.deleteApiError(['INPUT_CREATE', 'INPUT_VALIDATE']);
		this.props.clearPersistedData('newInputs');

		this.setState({
			inputs: updatedInputs,
			saveButtonActive: buttonActive,
			errors: null
		});
	}

	storeRouteState() {

		this.props.persistData("newInputs", this.state);

	}

	onSubtypeClick() {
		let constants = this.props.app.config.constants;

		this.createInput({
			type: constants.INPUT_SUBTYPE_PINTEREST
		});
	}

	cancelCreation(e) {

		e.preventDefault();

		this.props.clearPersistedData('newInputs');
		this.props.router.navigate('/share/automate/detail/' + this.state.routeId);

	}

	render() {
		let header = null,
			section = 'Your Route',
			currentPath = this.props.router.location.pathname,
			saveAction = this.state.saveButtonActive ? this.addInputToRoute : null,
			buttonLabel = null,
			content = null,
			modal = this.state.currentModal,
			label = 'Feed',
			type = 100,
			errorBlock = null,
			inputCount = 0,
			twitterInput = false,
			constants = this.props.app.config.constants,
			errorMessage = '';

		if (this.state.feedValidating) {
			buttonLabel = (
				<div>
					<i className="fa fa-spinner fa-pulse"></i> Working
				</div>
			);
		} else {
			buttonLabel = 'Save';
		}

		if (this.state.route.name) {
			section = this.state.route.name;
		}
		header = (
			<Header
				section={section}
				action="Add Feed" />
		);

		if (this.state.route.inputs && this.state.route.inputs.length) {
			inputCount = this.state.route.inputs.length;
			for (let i = 0; i < this.state.route.inputs.length; ++i) {
				if (this.state.route.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					twitterInput = true;
					break;
				}
			}
		}

		if (currentPath.match('configure') && !_.isEmpty(this.state.inputToConfigure)) {
			modal = (
				<InputModal
					{...this.props}
					input={this.state.inputToConfigure}
			        errors={this.state.errors}
			        onModalClose={this.onModalClose}
			        onSave={this.onConfigSave}
					linkPrefix={"detail/" + this.state.routeId + "/input/new/configure"} />
			);
		}

		if (this.state.inputs.length === 1) {
			label = this.state.inputs[0].name;
			type = this.state.inputs[0].type;
		} else {
			if (this.state.inputs.length > 1) {
				label = 'Feeds';
			}
		}

		if (this.state.errors && this.state.errors.errors && this.state.errors.errors.validation) {
			saveAction = null;
			if (Object.keys(this.state.errors.errors.validation).length) {
				 for (let key in this.state.errors.errors.validation) {
					 errorMessage = this.state.errors.errors.validation[key];
				 }
			} else {
				errorMessage = this.state.errors.errors.validation;
			}
			errorBlock = (
				<div className="detail-status error">
					<i className="fa fa-exclamation-circle error"></i>
					<div className="status-message">{errorMessage}</div>
				</div>
			);
		}

		content = (
			<div>
				<FeedEditorTabs
					{...this.props}
					inputType={type}
					feedLabel={label}
					showOrientation={false}
					showSocial={false}
					routeViewType={this.props.app.flags.routeViewType} />
				{errorBlock}
				<CreateFeed
					{...this.props}
					user={this.props.user}
					onFeedSelect={this.createInput}
					initialFeeds={this.state.inputs}
					canAddFeeds={this.state.canAddFeeds}
					onSocialClick={this.storeRouteState}
					onFeedRemoval={this.onRemoveInput}
					onAdvancedFeedConfigure={this.onConfigClick}
					onSubtypeClick={this.onSubtypeClick}
					routeViewType={this.props.app.flags.routeViewType}
					recordPath={this.props.recordPath}
					searchErrors={this.state.searchErrors}
					inputCount={inputCount}
					twitterInput={twitterInput}/>
				<EditorButtons
					{...this.props}
					saveActive={this.state.saveButtonActive}
					saveAction={saveAction}
					saveLabel={buttonLabel}
					cancelAction={this.cancelCreation} />
			</div>
		);

		return (
			<Content
				header={header}
				main={content}
				modal={modal} />
		);

	}
};

InputNew.displayName = "InputNew";

const enhance = compose(
	ComponentWithContext,
	FeedProvider
);

export default enhance(InputNew);
